/**
 * Check if first Int32 is greater than second
 *
 * @param {import('./Int32Type.js').BrandedInt32} a - First value
 * @param {import('./Int32Type.js').BrandedInt32} b - Second value
 * @returns {boolean} True if a > b
 */
export function greaterThan(a, b) {
	return a > b;
}
